export default __webpack_public_path__ + "static/media/EVENT26A2.9d22af8e.png";